import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import QRCode from "qrcode.react";
import PublicBookProfileSumPDF from "./PublicBookProfileSumPDF";
import PublicBookProfileSum from "./PublicBookProfileSum";
import LoginPublic from "../Loginpub";
import { BookIcon } from "../../icons";
import { Button, Card, CardBody } from "@windmill/react-ui";

export const BookContext = React.createContext();

export default function PublicBookProfile() {
  const [cover, setCover] = useState();
  const [book, setBook] = useState();

  const { id } = useParams();
  const { REACT_APP_BOOKS, REACT_APP_ATENEA } = process.env;

  function reload() {
    if (!id) return;

    fetch(`${REACT_APP_BOOKS}pubbiblioteca/${id}`)
      .then(async (resp) => {
        if (!resp.ok) throw new Error("Error cargando libro");
        return resp.json();
      })
      .then((resp) => {
        setBook(resp);

        fetch(`${REACT_APP_BOOKS}cover/${resp._id}`)
          .then((a) => (a.ok ? a.blob() : null))
          .then((blob) => {
            if (!blob) return;
            const url = URL.createObjectURL(blob);
            setCover(url);
          });
      })
      .catch(console.error);
  }

  useEffect(() => {
    reload();
  }, [id]);

  if (!book) {
    return (
      <div className="h-screen flex items-center justify-center text-gray-600">
        Cargando información del libro...
      </div>
    );
  }

  return (
    <>
      {/* NAVBAR */}
      <div className="bg-white border-b shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
            <a href="/">
          <div className="flex items-center gap-3">
            <BookIcon className="w-6 h-6 text-purple-600" />
            <span className="font-semibold text-lg">
              Biblioteca INSTIPP
            </span>
          </div>
            </a>

          <Button
            size="small"
            onClick={() => (window.location = REACT_APP_ATENEA)}
          >
            Iniciar sesión
          </Button>
        </div>
      </div>

      {/* CONTENIDO */}
      <div className="bg-gray-50 min-h-screen py-10">
        <div className="max-w-6xl mx-auto px-6">

          <Card className="shadow-lg">
            <CardBody className="grid md:grid-cols-3 gap-8">

              {/* PORTADA */}
              <div className="flex flex-col items-center">
                {cover && (
                  <img
                    src={cover}
                    alt="cover"
                    className="rounded-lg shadow-md w-56"
                  />
                ) }

                <div className="mt-4">
                  <QRCode
                    value={`${window.location.protocol}//${window.location.host}/biblioteca/${book._id}`}
                  />
                </div>
              </div>

              {/* INFO + RESUMEN */}
              <div className="md:col-span-2 space-y-4">

                <h1 className="text-3xl font-bold text-gray-800">
                  {book.nombre}
                </h1>

                <div className="grid grid-cols-2 gap-2 text-gray-600">
                  <p><strong>Autor:</strong> {book.autor}</p>
                  <p><strong>Año:</strong> {book.year}</p>
                  <p><strong>Editorial:</strong> {book.editorial}</p>
                  <p><strong>ISBN:</strong> {book.isbn}</p>
                </div>

                {/* RESUMEN AQUÍ (IMPORTANTE) */}
                <div className="pt-4 border-t">
                  <BookContext.Provider value={{ reload, book }}>
                    <PublicBookProfileSum />
                  </BookContext.Provider>
                </div>

              </div>

              {/* ACCESO DOCUMENTO */}
             
            </CardBody>
             <div className="bg-gray-100 border rounded-lg p-4 h-fit m-5">
                <h3 className="font-semibold mb-3">
                  Acceso al documento
                </h3>

                {book.almacenamiento !== "Físico" &&
                book.acceso !== "PRIVATE" &&
                book.ruta ? (
                  <BookContext.Provider value={{ reload, book }}>
                    <PublicBookProfileSumPDF />
                  </BookContext.Provider>
                ) : (
                  <p className="text-sm text-gray-500">
                    Disponible solo en biblioteca física
                  </p>
                )}
              </div>

          </Card>

        </div>
      </div>

    </>
  );
}
